import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import WatchAlertsForm from "./watch-alerts-form";
import WatchAlertsData from "./watch-alerts-data";

const WatchAlerts = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_WATCH_ALERT",
      "DEVELOPER_WATCH_ALERT"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("WATCH_ALERTS")}
        subTitle={i18n.get("WATCH_ALERT_DASHBOARD")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <WatchAlertsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <WatchAlertsData />
    </ET3PageDiv>
  );
});

export default WatchAlerts;
